// generated by srcset-codegen
import src from "./ambient-on-lockup-neon.png";
import src2x from "./ambient-on-lockup-neon@2x.png";
import src3x from "./ambient-on-lockup-neon@3x.png";

const width = 508;
const height = 83;
const srcSet = `${src2x} 2x, ${src3x} 3x`;
export default { src, width, height, srcSet };
